import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import PlusIcon from '../../icons/Icon-Plus-Grey.svg';
import { useFeatureToggle } from '../../utils/hooks/useFeatureToggle';
import useLocalize from '../../utils/hooks/useLocalize';
import AddToMarketBoardModal from './AddToMarketBoardModal';

/**
 * The 「+」 entry point that opens the add-to-Market-Board flow, modelled on
 * the Market Board's own "+" affordance. Gated by
 * `X-FEATURE-AI-SCANNER-POPSICLE-ENABLED`; nothing renders while the flag is
 * off.
 *
 * @param {object} props Component props.
 * @param {string|Array<string>} props.symbol Symbol id(s) to register.
 * @returns {JSX.Element|null} The 「+」 button and, when open, the flow.
 */
export const AddToMarketBoardButton = ({ symbol }) => {
  const { isFeatureEnabled } = useFeatureToggle('aiScannerPopsicleEnabled');
  const localize = useLocalize();
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  if (!isFeatureEnabled || !symbol) {
    return null;
  }

  return (
    <>
      <IconButton
        classes={{ root: 'add-to-board-trigger' }}
        aria-label={localize('marketboard.register.open')}
        onClick={handleOpen}
        size="large"
      >
        <img src={PlusIcon} alt="" />
      </IconButton>
      <AddToMarketBoardModal
        open={open}
        onClose={handleClose}
        symbol={symbol}
      />
    </>
  );
};

AddToMarketBoardButton.propTypes = {
  symbol: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};

export default AddToMarketBoardButton;
